import axios from "core/axios";

import { extendedProfileInfoResponseType, profileProps } from "./profileTypes";



const profileApi = {

  fetchMe: () => {

    return axios.get(`/profile/getProfileInfo`, {

      headers: {

        Authorization: `Bearer ${window.localStorage.accessToken}`,

      },

    });

  },

  editProfile: (data: profileProps) => {

    return axios.put(`/profile/saveProfileInfo`, data, {

      headers: {

        Authorization: `Bearer ${window.localStorage.accessToken}`,

      },

    });

  },

  getProfileBalance: () => {

    return axios.get(`/payment/getVelvetEntitlement`, {

      headers: {

        Authorization: `Bearer ${window.localStorage.accessToken}`,

      },

    });

  },

  getExtendedProfileInfo: () => {

    return axios.get<extendedProfileInfoResponseType>(

      `/profile/getExtendedProfileInfo`,

      {

        headers: {

          Authorization: `Bearer ${window.localStorage.accessToken}`,

        },

      }

    );

  },

  fbLink: (token: string) => {

    return axios.put(

      `/auth/linkFacebook?facebookToken=${token}`,

      {},

      {

        headers: {

          Authorization: `Bearer ${window.localStorage.accessToken}`,

        },

      }

    );

  },

  googleLink: (token: string) => {

    return axios.put(

      `/auth/linkGoogle?googleToken=${token}`,

      {},

      {

        headers: {

          Authorization: `Bearer ${window.localStorage.accessToken}`,

        },

      }

    );

  },

  fbUnlink: () => {

    return axios.delete(`/auth/unlinkFacebook`, {

      headers: {

        Authorization: `Bearer ${window.localStorage.accessToken}`,

      },

    });

  },

  googleUnlink: () => {

    return axios.delete(`/auth/unlinkGoogle`, {

      headers: {

        Authorization: `Bearer ${window.localStorage.accessToken}`,

      },

    });

  },

  // Анти-скам проверка перед новым чатом (как messagesService.antiScamCheck в приле):
  // отвечает showVerification/needVerification или ошибкой 119 (notVerified).
  antiScamCheck: () => {
    return axios.get(`/antiScamCheck`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.accessToken}`,
      },
    });
  },
  restoreProfile: () => {// TODO params(?)

    return axios.delete(`/profile/restoreProfile`, {

      headers: {

        Authorization: `Bearer ${window.localStorage.accessToken}`,

      },

    });

  }

};



export default profileApi

